
/**
 * 리뷰 작성 요청
 */
export interface ReviewCreateRequest {
  /**
   * 리뷰 내용
   * @maxLength 1000
   */
  content: string;
  /**
   * 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  rating: number;
  /**
   * 리뷰 태그 (최대 5개)
   * @maxItems 5
   */
  tags?: string[];
  /**
   * 리뷰 제목
   * @maxLength 100
   */
  title?: string;
}
